export const mainActionTypes = {
    SET_AUTH_TOKEN:"SET_AUTH_TOKEN",
    DELETE_AUTH_TOKEN: "DELETE_AUTH_TOKEN",
    SET_USERNAME: "SET_USERNAME",
}